import { render, staticRenderFns } from "./_provider.vue?vue&type=template&id=834a6d2c&lang=pug&"
import script from "./_provider.vue?vue&type=script&lang=js&"
export * from "./_provider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports